var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardUtilized(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_30361",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_30361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66634 28.3327C4.88717 28.3327 4.22016 28.0553 3.6653 27.5004C3.11044 26.9455 2.83301 26.2785 2.83301 25.4993V8.49935C2.83301 7.72018 3.11044 7.05317 3.6653 6.49831C4.22016 5.94345 4.88717 5.66602 5.66634 5.66602H28.333C29.1122 5.66602 29.7792 5.94345 30.3341 6.49831C30.8889 7.05317 31.1663 7.72018 31.1663 8.49935V25.4993C31.1663 26.2785 30.8889 26.9455 30.3341 27.5004C29.7792 28.0553 29.1122 28.3327 28.333 28.3327H5.66634ZM5.66634 16.9993H28.333V11.3327H5.66634V16.9993Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardUtilized);
export default __webpack_public_path__ + "static/media/credit_card_utilized.2f6df34bdae09be6cd8efb20ae2342fe.svg";
export { ForwardRef as ReactComponent };